<div class="faq-container" *ngIf="!loading">
  <!-- Title Bar -->
  <div class="faq-title-bar">
    <h2 class="faq-title">Frequently Asked Questions</h2>
  </div>

  <!-- Subtitle + Add Row -->
  <div class="faq-header">
    <p class="faq-subtitle">Find answers to your questions here</p>
    <div class="faq-header-right" *ngIf="canAddFaq">
      <button class="btn-add-faq" (click)="openAddEditQuestionsModal()">
        <span class="material-icons add-icon">add_circle_outline</span>
        Add New
      </button>
    </div>
  </div>

  <!-- Content Split Layout -->
  <div class="faq-split-container" *ngIf="currentPageRecords && currentPageRecords.length > 0">
    <!-- Left Column: FAQ Topics -->
    <div class="faq-sidebar">
      <div
        *ngFor="let topic of currentPageRecords"
        class="faq-sidebar-card"
        [class.active]="selectedTopic?.id === topic.id"
        (click)="selectTopic(topic)"
      >
        <span class="topic-title">{{ topic.title }}</span>
        <div class="topic-actions">
          <button
            *ngIf="canEditFaq || canDeleteFaq"
            class="btn-more"
            (click)="togglePopup($event, topic)"
          >
            <i class="material-icons">more_horiz</i>
          </button>
          <div
            class="faq-action-popup"
            *ngIf="activePopupId === topic.id"
            (click)="$event.stopPropagation()"
          >
            <button
              *ngIf="canEditFaq"
              class="faq-action-item"
              (click)="openAddEditQuestionsModal(topic.id)"
            >
              <img
                src="/assets/images/d-edit 1.svg"
                style="margin-bottom: 3px; margin-right: 8px;"
              />
              <span style="color: rgba(63, 81, 181, 1); font-weight: 500;">Edit</span>
            </button>
            <button
              *ngIf="canDeleteFaq"
              class="faq-action-item"
              (click)="openDeletePopup(topic, $event)"
            >
              <img
                src="/assets/images/bin.svg"
                style="margin-bottom: 3px; margin-right: 8px;"
              />
              <span style="color: rgba(222, 52, 40, 1); font-weight: 500;">Delete</span>
            </button>
          </div>
          <i class="material-icons chevron-icon">chevron_right</i>
        </div>
      </div>
    </div>

    <!-- Right Column: Q&A Accordion -->
    <div class="faq-content">
      <ng-container *ngIf="selectedTopic?.questionsAndAnswers?.length > 0; else noQuestions">
        <div
          *ngFor="let item of selectedTopic.questionsAndAnswers; let i = index"
          class="faq-accordion-card"
          [class.expanded]="expandedQuestionIndex === i"
        >
          <div class="faq-accordion-header" (click)="toggleQuestion(i)">
            <h4 class="faq-question-text">{{ item.question }}</h4>
            <i class="material-icons chevron-toggle">
              {{ expandedQuestionIndex === i ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </i>
          </div>

          <div class="faq-accordion-body" *ngIf="expandedQuestionIndex === i">
            <p class="faq-answer-text">{{ item.answer }}</p>
            <div class="faq-hashtags-container" *ngIf="getFormattedHashtags(item).length > 0">
              <span *ngFor="let tag of getFormattedHashtags(item)" class="faq-hashtag">
                {{ tag }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noQuestions>
        <div class="faq-empty-state">
          <img src="/assets/images/GRBES-List.svg" alt="" class="faq-empty-icon" />
          <h4 class="faq-empty-title">No questions available for this topic</h4>
          <ng-container *ngIf="canEditFaq">
            <p class="faq-empty-subtitle">
              Click "Add Question Set" below to add questions for this topic.
            </p>
            <button
              type="button"
              class="btn-add-question-set"
              (click)="openAddEditQuestionsModal(selectedTopic.id)"
            >
              <span class="plus-icon">+</span> Add Question Set
            </button>
          </ng-container>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="no-records-message" *ngIf="!currentPageRecords || currentPageRecords.length === 0">
    Sorry, you do not have any FAQ.
  </div>
</div>

<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>

